import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="livestream-events.title" defaultMessage="Events" />;
